import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { API_BASE_URL, getAuthHeaders } from '../utils/utils.js';

const SuccessPage = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    const verifySession = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/verify-token`, {
          method: 'POST',
          headers: getAuthHeaders(),
        });

        if (response.ok) {
          const data = await response.json();
          // Update the user context with the latest data from the server (e.g., new credits)
          setUser(data.user);
        } else {
            console.error("Failed to refresh user data after payment.");
        }
      } catch (error) {
        console.error("Error while refreshing user data:", error);
        } finally {
        // Redirect to the homepage after a short delay, regardless of success or failure.
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    };

    verifySession();
  }, [navigate, setUser]); // Run only once on component mount

  return (
    <div>Finalizing your payment... You will be redirected shortly.</div>
  );
};

export default SuccessPage;